export const ChartConfig = {
  Dark: {
    CURRENT_TIME_BAR_COLOR: '#f1ffe7',
    CURRENT_TIME_BAR_COLOR_HOVER: '#47c3ff',
    BAR_COLOR: '#3581b8',
    BAR_COLOR_HOVER: '#47c3ff',
    XLABEL_HIGHT_LIGHT_COLOR: '#ffffff',
  },
  Light: {
    CURRENT_TIME_BAR_COLOR: '#2c73e8',
    CURRENT_TIME_BAR_COLOR_HOVER: '#47c3ff',
    BAR_COLOR: '#2b457d',
    BAR_COLOR_HOVER: '#47c3ff',
    XLABEL_HIGHT_LIGHT_COLOR: '#1f2023',
  },
  Classic: {
    CURRENT_TIME_BAR_COLOR: '#f1ffe7',
    CURRENT_TIME_BAR_COLOR_HOVER: '#47c3ff',
    BAR_COLOR: '#3581b8',
    BAR_COLOR_HOVER: '#47c3ff',
    XLABEL_HIGHT_LIGHT_COLOR: '#ffffff',
  },
};
